import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, watch } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchFilter',
  props: {
    "modelValue": {},
    "modelModifiers": {},
  },
  emits: /*@__PURE__*/_mergeModels(['search'], ["update:modelValue"]),
  setup(__props, { emit: __emit }) {

const model = _useModel<string>(__props, "modelValue")

const query = ref('');

const emit = __emit
function search() {
  model.value = query.value;
  emit('search', query.value)
}

watch(model, (value) => {
  query.value = model.value
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "relative",
    onSubmit: _withModifiers(search, ["prevent"])
  }, [
    _withDirectives(_createElementVNode("input", {
      type: "text",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
      class: "block pr-10 w-full rounded border transition border-neutral-200 hover:border-teal focus:ring-teal focus:border-teal"
    }, null, 512), [
      [_vModelText, query.value]
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex absolute inset-y-0 right-0 items-center" }, [
      _createElementVNode("button", {
        type: "submit",
        class: "block px-2"
      }, [
        _createElementVNode("span", { class: "text-2xl material-symbols-outlined" }, "search")
      ])
    ], -1))
  ], 32))
}
}

})